<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col-8">
      <h2>
        Skill Tree
      </h2>
    </div>
  </div>

  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหา Skill Tree" name="searchName" [(ngModel)]="search"
      (keyup)="searching()">
    <lifedi-btn lable="เพิ่ม Skill Tree" customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF" (click)="addSkillTree()">
    </lifedi-btn>
  </div>

  <div class="container mt-4" style="width: 90%; margin: 0 auto;">
    <div *ngIf="rows?.length === 0" class="mt-4 mb-4">
      ไม่พบ Skill Tree
    </div>
    <div *ngIf="rows?.length > 0">
      <mat-card *ngFor="let skilltree of rows" class="mb-3" style="padding: 25px 40px;">
        <div class="row">
          <div class="col-10 text-left">
            {{skilltree.TREE_NAME}} ({{getCountCourse(skilltree.TREE_NODES)}}) <br>
            <mat-chip-list aria-label="teachers skilltree selected">
              <mat-chip *ngFor="let t of skilltree.TEACHERS_DETAIL" class="mt-3" color="primary" selected>{{t.USERNAME}}
              </mat-chip>
            </mat-chip-list>
            <!-- {{getTeacherName(skilltree.TEACHERS_DETAIL)}} -->
          </div>
          <div class="col-2 text-right align-items-center" style="display: grid;">
            <a *ngIf="!skilltree.VIEW_ONLY" (click)="edit(skilltree.TREE_ID)" style="cursor: pointer;">
              <img src="../../../../assets/edit.png" style="width: 20px;">
            </a>
            <a *ngIf="skilltree.VIEW_ONLY" (click)="edit(skilltree.TREE_ID)" style="cursor: pointer;">
              <img src="../../../../assets/other/visibility (black).png" style="width: 20px;">
            </a>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <div class="d-flex justify-content-center p-2">
    <ngb-pagination *ngIf="!isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refresh()">
    </ngb-pagination>
    <ngb-pagination *ngIf="isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refreshSearch()">
    </ngb-pagination>
  </div>
  <select class="custom-select" style="width: auto; float: right; margin-right: 30px;" [(ngModel)]="pageSize"
    (ngModelChange)="refresh()">
    <option [ngValue]="10">10 items per page</option>
    <option [ngValue]="15">15 items per page</option>
    <option [ngValue]="20">20 items per page</option>
  </select>
</div>
